import { render, staticRenderFns } from "./service-details.vue?vue&type=template&id=1c93e24e"
import script from "./service-details.vue?vue&type=script&lang=js"
export * from "./service-details.vue?vue&type=script&lang=js"
import style0 from "./service-details.vue?vue&type=style&index=0&id=1c93e24e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports